module.exports = __webpack_public_path__ + "static/media/TEN.747d66ea.png";